/** Must match backend AmmoScoreCalculator.MinScoreToCreatePost */
export const MIN_AMMO_SCORE_TO_CREATE_POST = 10

export function canCreateCommunityPost (user: {
  isAdmin?: boolean;
  isModerator?: boolean;
  ammoScore?: number;
} | null | undefined): boolean {
  if (!user) return false
  if (user.isAdmin || user.isModerator) return true
  return (user.ammoScore ?? 0) >= MIN_AMMO_SCORE_TO_CREATE_POST
}
